/* unplugin-vue-components disabled */import script from "./reserve_Zh.vue?vue&type=script&setup=true&lang=ts"
export * from "./reserve_Zh.vue?vue&type=script&setup=true&lang=ts"

import "./reserve_Zh.vue?vue&type=style&index=0&id=6c255d5b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c255d5b"]])

export default __exports__